//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { notificationListApi, notificationRoutine, notificationWechat, notificationSms, notificationDetail, notificationUpdate } from '@/api/systemFormConfig';
import { wechatAsyncApi, routineAsyncApi } from '@/api/wxApi';
import { Debounce } from '@/utils/validate';
import { checkPermi } from '@/utils/permission';
export default {
  name: 'MerchantNotification',
  data: function data() {
    return {
      modalTitle: '',
      notificationModal: false,
      headerList: [{
        label: '通知会员',
        value: '1'
      }, {
        label: '通知管理员',
        value: '2'
      }],
      id: 0,
      levelLists: [],
      currentTab: '1',
      loading: false,
      formData: {},
      industry: null,
      loadingList: false,
      centerDialogVisible: false,
      infoList: [],
      infoList1: [{
        label: '短信',
        value: 'sms'
      }],
      form: {
        content: '',
        name: '',
        id: '',
        status: null,
        tempId: '',
        tempKey: '',
        title: ''
      },
      detailType: '',
      infoTab: ''
    };
  },
  created: function created() {
    if (checkPermi(['distribution:system:notification:list'])) this.getNotificationList(Number(this.currentTab));
  },
  methods: {
    checkPermi: checkPermi,
    changeTab: function changeTab(data) {
      this.currentTab = data.name;
      this.getNotificationList(data.name);
    },
    // 获取消息列表
    getNotificationList: function getNotificationList(id) {
      var _this = this;
      _this.loadingList = true;
      notificationListApi({
        sendType: id
      }).then(function (res) {
        _this.loadingList = false;
        _this.levelLists = res;
      }).catch(function () {
        _this.loadingList = false;
      });
    },
    // 公众号消息开关
    changeWechat: function changeWechat(row) {
      var _this = this;
      notificationWechat(row.id).then(function () {
        _this.$modal.msgSuccess('修改成功');
      });
    },
    // 小程序消息开关
    changeRoutine: function changeRoutine(row) {
      var _this = this;
      notificationRoutine(row.id).then(function () {
        _this.$modal.msgSuccess('修改成功');
      });
    },
    // 短信消息开关
    changeSms: function changeSms(row) {
      var _this = this;
      notificationSms(row.id).then(function () {
        _this.$modal.msgSuccess('修改成功');
      });
    },
    // 详情 tab 切换
    changeInfo: function changeInfo(data) {
      this.getNotificationDetail(data);
    },
    // 获取详情数据
    getNotificationDetail: function getNotificationDetail(param) {
      var _this = this;
      _this.loading = true;
      var data = {
        id: _this.id,
        type: param.name
      };
      _this.$set(_this, 'detailType', data.type);
      notificationDetail(data).then(function (res) {
        _this.form = res;
        _this.$set(_this.form, 'status', res.status.toString());
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 打开详情弹窗
    setting: function setting(row) {
      this.infoList = [];
      this.id = row.id;
      this.centerDialogVisible = true;
      if (row.isWechat !== 0) {
        this.infoList.push({
          label: '公众号模板消息',
          value: 'wechat'
        });
      }
      if (row.isRoutine !== 0) {
        this.infoList.push({
          label: '小程序订阅消息',
          value: 'routine'
        });
      }
      if (row.isSms !== 0) {
        this.infoList.push({
          label: '短信',
          value: 'sms'
        });
      }
      this.infoTab = this.infoList[0].value;
      this.getNotificationDetail({
        name: this.infoTab
      });
    },
    // 修改通知
    submit: Debounce(function () {
      var _this = this;
      var data = {
        id: _this.id,
        status: Number(_this.form.status),
        tempId: _this.form.tempId,
        type: _this.detailType
      };
      notificationUpdate(data).then(function () {
        _this.$modal.msgSuccess('修改成功');
        _this.centerDialogVisible = false;
        _this.getNotificationList(_this.currentTab);
      });
    }),
    syncWechat: function syncWechat() {
      wechatAsyncApi().then(function () {
        this.$message && this.$message.success('同步成功');
      }.bind(this));
    },
    syncRoutine: function syncRoutine() {
      routineAsyncApi().then(function () {
        this.$message && this.$message.success('同步成功');
      }.bind(this));
    }
  }
};